import { tempoApi } from '@/lib/api/tempoApi';
import type { Scenario } from '@/lib/api/types/loop-planner/scenario';

const getSandbox = async ({ loopId }: { loopId: number }) => {
  const response = await tempoApi()
    .get(`api/v1/adaptive-planner/loops/${loopId}/sandbox`)
    .json<Scenario>();
  return response;
};

const createSandbox = async ({ loopId }: { loopId: number }) => {
  const response = await tempoApi()
    .post(`api/v1/adaptive-planner/loops/${loopId}/sandbox`)
    .json<Scenario>();
  return response;
};

const deleteSandbox = async ({ loopId }: { loopId: number }) => {
  await tempoApi().delete(`api/v1/adaptive-planner/loops/${loopId}/sandbox`);
};

export const LoopPlannerSandboxApi = {
  getSandbox,
  createSandbox,
  deleteSandbox,
} as const;
